import React from 'react';
import PropTypes from 'prop-types';

const OUTLOOK_DEFAULT_COLOR = '#0072C6';

export default function Outlook({ logoColor, logoWidth, logoHeight, decorative }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={logoWidth}
            height={logoHeight}
            viewBox="0 0 25 24"
            fill="none"
            aria-hidden={decorative ? 'true' : undefined}
            focusable={decorative ? 'false' : undefined}
        >
            {!decorative ? <title>Calendar Attachment Outlook</title> : null}
            <path
                d="M8.769 1.12498C5.60453 1.73991 2.47759 2.34732 1.82149 2.47472L0.632812 2.70335V11.8858C0.632812 20.5919 0.636688 21.0644 0.700384 21.0833C0.734049 21.0944 3.83483 21.7469 7.58808 22.5306C11.3413 23.3177 14.4496 23.9702 14.4983 23.9814L14.5809 24V11.9982C14.5809 5.39531 14.5697 0 14.5547 0C14.5356 0.00387573 11.9337 0.510056 8.769 1.12498ZM8.18411 7.83273C8.77288 7.91895 9.23014 8.14758 9.67262 8.58255C10.3701 9.26505 10.7262 10.1386 10.8313 11.4208C10.9325 12.6843 10.6738 13.9028 10.1226 14.7541C9.68401 15.4327 9.18533 15.8265 8.46917 16.0476C8.22916 16.1227 8.10927 16.1377 7.66316 16.1377C7.06712 16.1377 6.7932 16.074 6.31342 15.8265C5.94965 15.6391 5.36476 15.0503 5.13613 14.6417C4.92251 14.2668 4.73869 13.7756 4.63358 13.3145C4.52484 12.8158 4.51369 11.4097 4.61856 10.8887C4.87722 9.58765 5.48464 8.63535 6.36961 8.14031C6.87555 7.85888 7.55417 7.74263 8.18411 7.83273Z"
                fill={logoColor || OUTLOOK_DEFAULT_COLOR}
            />
            <path
                d="M7.33303 9.42246C6.8082 9.56875 6.39575 10.0899 6.17438 10.8885C6.09931 11.1546 6.0918 11.2747 6.0918 11.9945C6.0918 12.7107 6.09931 12.8345 6.17438 13.1006C6.35433 13.7531 6.69171 14.2404 7.10803 14.4504C7.303 14.5516 7.36306 14.5627 7.68179 14.5627C8.01165 14.5627 8.06057 14.5516 8.2892 14.439C8.78424 14.1953 9.1066 13.6666 9.26039 12.8567C9.33911 12.4518 9.32046 11.4058 9.22673 10.9669C9.07681 10.2546 8.72418 9.70341 8.28945 9.49706C8.03805 9.37742 7.60671 9.34375 7.33303 9.42246Z"
                fill={logoColor || OUTLOOK_DEFAULT_COLOR}
            />
            <path
                d="M15.4805 7.4464L15.4841 9.80099L16.2976 10.3072C16.7776 10.6072 17.1487 10.8134 17.2051 10.8134C17.2688 10.8134 18.495 10.0073 20.8307 8.43237L24.3665 6.05138L24.3403 5.92011C24.2878 5.62028 24.0516 5.29768 23.7891 5.17392C23.6317 5.09521 23.598 5.09521 19.5561 5.09521H15.4805V7.4464Z"
                fill={logoColor || OUTLOOK_DEFAULT_COLOR}
            />
            <path
                d="M20.8123 10.3072C17.9927 12.1781 17.2877 12.6317 17.1903 12.6317C17.108 12.6317 16.9879 12.5756 16.8079 12.4518C16.6655 12.3542 16.3092 12.1105 16.0167 11.9081L15.4805 11.5407V14.7279V17.9188H19.3725C23.8194 17.9188 23.5794 17.9338 23.9618 17.5887C24.1529 17.4162 24.2766 17.1651 24.3292 16.865C24.3742 16.5838 24.3817 7.98263 24.3403 7.98263C24.3219 7.98263 22.7358 9.02865 20.8123 10.3072Z"
                fill={logoColor || OUTLOOK_DEFAULT_COLOR}
            />
        </svg>
    );
}

Outlook.defaultProps = {
    logoColor: null,
    logoWidth: 21,
    logoHeight: 24,
    decorative: false,
};
Outlook.propTypes = {
    logoColor: PropTypes.string,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number,
    decorative: PropTypes.bool,
};
